import type { BibAssign } from '@/objects/generated';
import {
    EventCommonValuesArray,
    useCommonStore,
    useContestantStore,
    useRaceContestantTimeStore,
    type CommonValues,
    type ContestantValues,
    type TimeValues,
    useContestantTimeStore,
    type TrackValues,
    useMapstore,
    useBibAssignStore,
    type BibAssignValues,
    useGPIStore,
} from '@/stores';
import { useEventCommonStore, type EventCommonValues } from '@/stores';
import { useToastStore } from '@/stores/toastStore';
export const getEnsureLoadedLoader = (
    ds: EventCommonValues | CommonValues | ContestantValues | TimeValues | TrackValues | BibAssignValues,
) => {
    return async () => {
        try {
            if (ds == 'Contestants' || ds == 'RelayContestants') {
                await useContestantStore().EnsureLoaded([ds]);
            } else if (ds == 'Tracks') {
                await useMapstore().EnsureLoaded([ds as TrackValues]);
            } else if (ds == 'BibAssign') {
                await useBibAssignStore().EnsureLoaded([ds as BibAssignValues]);
            } else {
                // check if ds is in EventCommonValues
                if (EventCommonValuesArray.map((c) => c.toString()).includes(ds.toString())) {
                    await useEventCommonStore().EnsureLoaded([ds as EventCommonValues]);
                } else if (ds == 'RaceContestantTimes') {
                    await useRaceContestantTimeStore().EnsureLoaded();
                } else if (ds == 'ContestantTimes') {
                    await useContestantTimeStore().EnsureLoaded();
                } else if (ds == 'GpiReadings') {
                    await useGPIStore().EnsureLoaded();
                } else {
                    await useCommonStore().EnsureLoaded([ds as CommonValues]);
                }
            }
        } catch (error: any) {
            useToastStore().addError(error.message);
            throw error;
        }
    };
};
